import { render, staticRenderFns } from "./dragDropBlockSelector.vue?vue&type=template&id=1da8616e&"
import script from "./dragDropBlockSelector.vue?vue&type=script&lang=js&"
export * from "./dragDropBlockSelector.vue?vue&type=script&lang=js&"
import style0 from "./dragDropBlockSelector.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports